import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Palette } from 'Palette';
import { BUTTON_FONT_SIZE, RADIUS } from 'DesignTokens';
import { determineNextTone } from './stylesToneUtils';

export const CircularActionIcon = styled(IconButton)<{
  className?: string;
}>(({ className }) => ({
  backgroundColor: Palette.default.buttonBg,
  color: Palette.default.buttonText,
  width: 40,
  height: 40,
  '&:hover': {
    backgroundColor: Palette[determineNextTone('default')].buttonBg,
    color: Palette[determineNextTone('default')].buttonText,
  },
  className: `react-CircularActionIcon ${className || ''}`.trim(),
}));

export const CircularTextButton = styled(IconButton)<{
  className?: string;
}>(({ className }) => ({
  backgroundColor: Palette.tone1.background,
  borderRadius: RADIUS.button,
  color: Palette.tone1.text,
  height: 40,
  fontFamily: 'Inter, sans-serif',
  fontSize: BUTTON_FONT_SIZE,
  '&:hover': {
    backgroundColor: Palette[determineNextTone('tone1')].background,
    color: Palette[determineNextTone('tone1')].text,
  },
  className: `react-CircularTextButton ${className || ''}`.trim(),
}));

export const StyledFilterButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{
  active?: boolean;
  className?: string;
}>(({ active = false, className }) => ({
  borderRadius: RADIUS.button,
  textTransform: 'none',
  fontFamily: 'Manrope; sans-serif',
  fontSize: '1rem',
  padding: '4px 16px',
  backgroundColor: active ? Palette.default.buttonBg : 'transparent',
  color: active ? Palette.default.buttonText : Palette.tone1.buttonText,
  border: `1px solid ${Palette[active ? 'tone2' : 'tone1'].buttonText}`,
  '&:hover': {
    backgroundColor: active ? Palette.tone2.buttonBg : Palette.tone1.buttonBg,
  },
  className: `react-StyledFilterButton ${className || ''}`.trim(),
}));
